export const countries = [
    { code: 'cs', flag: 'cz', label: 'Česky', phone: '1-264' },
    { code: 'en', flag: 'us', label: 'English', phone: '355' },
    { code: 'de', flag: 'de', label: 'Deutsch', phone: '374' },
]